import { deleteMypageNovelNovelId } from "../../../api/v1/mypage/novel/[novel_id]/delete"
import { MypageNovelNovelIdDeleteInputModel } from "../../../api/v1/mypage/novel/[novel_id]/DeleteInputModel"

export const deleteNovel = (novelId: number): Promise<void> => {
  return deleteMypageNovelNovelId(
    new MypageNovelNovelIdDeleteInputModel(novelId),
  )
}
